import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import Dashboard from '../components/Menu/Dashboard';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ChangePasswordForm from '../components/Users/ChangePasswordForm';
import { makeStyles } from '@material-ui/core';
import { updateUser } from './../actions/user'
import { createCode, changeCode, changeStatusUser } from './../actions/codes'
import { changeState, updateNextDateChangePassword } from './../actions/loginUser'
import { history } from '../helpers/history';
import DialogOTP from '../components/Complements/DialogOTP';
import { sendMobile } from '../functions/mobile';
import { filterArrayEqual } from '../functions/arrays';
import LoadingScreen from '../components/Complements/LoadingScreen';
//import { sendLogs } from '../functions/function-logs';
import { validateIp } from '../functions/store';
// import { checkNumber, checkPasswordLength, checkSpecialCharacters, checkUppercase, checkLowercase, passwordProgressControl } from '../functions/validators';
import { passwordProgressControl } from '../functions/validators';
import { encrypt } from './../functions/mobile';
import { feathersCreateData } from '../services';
//import Title from './../components/Complements/Title';
import Footer from '../components/Complements/Footer';
import { findValidators } from './../actions/validators'
import moment from 'moment';

class PasswordChangeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passwordNew: '',
            passwordRepeat: '',
            passworProvisional: '',
            openDialogOTP: false,
            otp: '',
            newPass: '',
            oldPassword: '',
            initialTime: Date.now(),
            seq: '',
            contAttempts: 0,
            loading: false,
            numberValid: false,
            uppercaseValid: false,
            lowercaseValid: false,
            specialCharValid: false,
            charNumberValid: false,
            progress: 0,
            validators: [],
            disableButton: true
        }
    }

    componentDidMount() {

        if ((this.props.user.flagResetPassword === 1)) {
            const typeUser = (this.props.user.type === "CLIENTE") ? "Cliente(a)" : "Socio(a)"
            this.props.handleOpenSnack(`Por favor modifique su contraseña provisional por temas de seguridad.`, "info")
        }
        this.props.findValidators("validators", {
            query: {
                type: {
                    $in: [40]
                },
                state: {
                    $in: [1]
                }
            }
        }).then(res => {
            const { data } = res.payload
            data.map(row => {
                row.validationState = false
                return null
            })
            this.setState({ validators: data })
        }).catch(error => {
        })

    }
    // functions

    validate = () => {
        if (this.state.oldPassword === "" || this.state.passwordNew === "" || this.state.passwordRepeat === "") {
            this.setState({ disableButton: true })
        } else {
            if (this.state.passwordNew === this.state.passwordRepeat) {
                this.setState({ disableButton: false })
            } else {
                this.setState({ disableButton: true })
            }
        }
    }

    handleChangeStatusUser = () => {

        this.props.changeStatusUser({ emited: "NAVCHANGESTATUS", iduser: this.props.user.id }).then(
            response => {
                // console.log(response)
            }
        ).catch(
            error => {
                //console.log(error)
            }
        )
    }
    handleChangePasswordNew = (event) => {
        // console.log('LA DATA ', event.target.value)

        /* const numberOfCharactersObj = filterArrayEqual(this.props.parameters, 'name', 'NUMBER_OF_CHARACTERS_PASSWORD_CHANGE_VALIDATION')
        const numberOfCharacters = (numberOfCharactersObj.length > 0) ? Number(numberOfCharactersObj[0].value) : 10 */

        const { value } = event.target
        // console.log('value pass', value)
        // const numberValid = checkNumber(value)
        // const uppercaseValid = checkUppercase(value)
        // const lowercaseValid = checkLowercase(value)
        // const specialCharValid = checkSpecialCharacters(value)
        // const charNumberValid = checkPasswordLength(value, numberOfCharacters)
        // this.setState({ passwordNew : value, numberValid, uppercaseValid, lowercaseValid, specialCharValid, charNumberValid })
        // this.setState({ progress: passwordProgressControl({numberValid, uppercaseValid, lowercaseValid, specialCharValid, charNumberValid }, 5) })
        let temporalValidator = this.state.validators

        // console.log('temporalValidator', temporalValidator)

        for (let i = 0; i < this.state.validators.length; i++) {

            try {
                if (temporalValidator[i].tittle !== 'Caracteres mínimos') {
                    temporalValidator[i].validationState = value.match(this.state.validators[i].expression) ? true : false
                } else {
                    if (value.length >= temporalValidator[i].expression) {
                        // console.log('Cantidad correcta')
                        temporalValidator[i].validationState = true
                    } else {
                        // console.log('Cantidad incorrecta')
                        temporalValidator[i].validationState = false
                    }
                }
                /* console.log('temporalValidator', temporalValidator[i])
                // console.log('temporalValidator state', temporalValidator[i].validationState) */
            } catch (error) {

            }
            this.setState({ validators: temporalValidator })
        }

        this.setState({ passwordNew: value, progress: passwordProgressControl(temporalValidator, this.state.validators.length) }, () => {
            this.validate()
        })
    }

    handleChangeInputOtp = (valueinput) => {
        const tokenLengthObj = filterArrayEqual(this.props.parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN')
        // console.log(tokenLengthObj)
        const tokenLength = (tokenLengthObj.length > 0) ? parseInt(tokenLengthObj[0].value) : 6
        if (valueinput.target.value.toString().length === tokenLength) {
            // console.log("VALUE OTP: ", valueinput)
            this.receiveOTP({ data: valueinput.target.value.toString() });
        }

    }


    receiveOTP = async (otp) => {

        try {

            this.setState({ loading: true })

            const { devices } = this.props;

            const sendData = encrypt(JSON.stringify({
                ip: devices.ip,
                mac: devices.mac,
                device: devices.device,
                type: 10,
                inputOtp: otp.data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type, viewDialogOtp } = responseValidateCode;

            if (error === false) {

                this.handleCloseDialogOTP()
                const { getDeviceData, updateIpDevice, devices } = this.props
                const { ip, mac, device } = devices
                let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                const { seq, newPass, oldPassword } = this.state
                //const { parameters } = this.props
                //let number_day_for_change_password = (parameters.length > 0) ? filterArrayEqual(parameters, 'name', 'NumberDaysChangePassword')[0].value : 365
                // console.log(id)
                let number_day_for_change_password = (this.props.parameters.length > 0) ? (filterArrayEqual(this.props.parameters, 'code', 'NUMBER_DAYS_CHANGE_PASSWORD').length > 0) ? parseInt(filterArrayEqual(this.props.parameters, 'code', 'NUMBER_DAYS_CHANGE_PASSWORD')[0].value) : 365 : 365;

                let next_date_change_password = moment().add(number_day_for_change_password, 'd');

                const sendData = encrypt(JSON.stringify({ emited: 'NAVCHANGE', id: seq, newPass, oldPassword, mac, device, ip: ipSend, type: 10, otp: otp.data }))
                this.props.changeCode({ sendData }).then(r => {
                    //console.log('lo que me devuelve ', r.payload)
                    if (r.payload) {
                        this.props.handleOpenSnack(r.payload.alert, r.payload.type)

                        let send = {
                            type: 'action',
                            action: 'updatePassword',
                            data: this.state.newPass
                        }

                        sendMobile(JSON.stringify(send))
                        this.setState({ loading: false })
                        if (r.payload.type === "success") {
                            this.props.changeState(0)
                            this.props.updateNextDateChangePassword(next_date_change_password)
                            if (this.props.user.flagUsernameChange === 1) {
                                history.push('/username-change')
                            } else {
                                history.push('/')
                            }

                        }
                    }
                }).catch(error => {
                    this.props.handleOpenSnack('Ha ocurrido un error al cambiar su contraseña. Por favor intente nuevamente.', 'error')
                    //console.log(error)
                    this.setState({ loading: false })
                })
                // history.push('/')
                // this.props.handleOpenSnack('Pago realizado', 'success')
            } else {
                this.props.handleOpenSnack(message, type)
                if (viewDialogOtp === false) {
                    this.handleCloseDialogOTP()
                }
                this.setState({ loading: false })
            }

        } catch (error) {
            this.setState({ loading: false })
            this.props.handleOpenSnack('Ha ocurrido un error al cambiar su contraseña. Por favor intente nuevamente.', 'error')
        }

    }
    // handle kyuin123
    handleSubmit = async (values) => {
        try {
            const { getDeviceData, updateIpDevice, devices } = this.props
            const { ip, mac, device } = devices
            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
            this.setState({ loading: true })

            const sendData = encrypt(JSON.stringify({ type: 10, emited: 'NAV', device, ip: ipSend, mac, newPass: values.passwordNew, oldPassword: values.oldPassword }))
            this.props.createCode({ sendData }).then(res => {
                const { alert, type } = res.payload

                if (type === "success") {
                    this.setState({ openDialogOTP: true, newPass: values.passwordNew, oldPassword: values.oldPassword, loading: false })
                } else {
                    this.props.handleOpenSnack(alert, type)
                    this.setState({ loading: false })
                }

            }).catch(error => {
                this.setState({ loading: false })
                this.props.handleOpenSnack('No se ha podido realizar la acción. Por favor intente nuevamente.', 'error')
            })
        } catch (error) {
            this.setState({ loading: false })
            //console.log('error submit', error)
            this.props.handleOpenSnack('No se ha podido realizar la acción. Por favor intente nuevamente.', 'error')
        }

    }

    handleCloseDialogOTP = () => {
        this.setState({ openDialogOTP: false })
    };

    handleChangeOldPassword = (event) => {

        const { value } = event.target

        this.setState({
            oldPassword: value
        }, () => {
            this.validate()
        })
    }

    handleChangeRepeatPassword = (event) => {

        const { value } = event.target

        this.setState({
            passwordRepeat: value
        }, () => {
            this.validate()
        })
    }

    refreshToken = async () => {

        try {
            const { getDeviceData, updateIpDevice, devices } = this.props
            const { ip, mac, device } = devices
            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
            this.setState({ loading: true })

            const sendData = encrypt(JSON.stringify({ type: 10, emited: 'NAV', device, ip: ipSend, mac }))
            this.props.createCode({ sendData }).then(res => {
                const { alert, type } = res.payload

                if (type === "success") {
                    this.setState({ openDialogOTP: true, loading: false })
                } else {
                    this.props.handleOpenSnack(alert, type)
                }

            }).catch(error => {
                this.setState({ loading: false })
                this.props.handleOpenSnack('No se ha podido realizar la acción. Por favor intente nuevamente.', 'error')
            })

        } catch (error) {
            this.setState({ loading: false })
            this.props.handleOpenSnack('No se ha podido realizar la acción. Por favor intente nuevamente.', 'error')
        }
    }

    // renders
    renderBody = () => {
        const timeLifeTokenObj = filterArrayEqual(this.props.parameters, 'code', 'TIME_LIFE_TOKEN')
        const timeLifeToken = (timeLifeTokenObj.length > 0) ? Number(timeLifeTokenObj[0].value) : 180000

        // const numberOfCharactersObj = filterArrayEqual(this.props.parameters, 'name', 'NUMBER_OF_CHARACTERS_PASSWORD_CHANGE_VALIDATION')
        // const numberOfCharacters = (numberOfCharactersObj.length > 0) ? Number(numberOfCharactersObj[0].value) : 10

        const useStyles = makeStyles(theme => ({
            textField: {
                width: 200,
            },
            margin: {
                margin: theme.spacing(1),
            },
            divStandard: {
                padding: "20px",
                backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
                borderRadius: "16px",
            }
        }));

        return <div>
            <ChangePasswordForm
                {...this.state}
                classes2={useStyles}
                onSubmit={this.handleSubmit}
                handleChangePasswordNew={this.handleChangePasswordNew}
                handleChangeOldPassword={this.handleChangeOldPassword}
                handleChangeRepeatPassword={this.handleChangeRepeatPassword}
                user={this.props.user}
            // numberOfCharacters={numberOfCharacters}
            />
            <DialogOTP
                {...this.state}
                showQR={false}
                onCloseDialogOTP={this.handleCloseDialogOTP}
                onKeyPress={this.handleChangeInputOtp}
                OTPSubmit={this.receiveOTP}
                initialTime={Date.now()}
                timeLifeToken={timeLifeToken}
                refreshToken={this.refreshToken}

            />
        </div>
    }
    render() {
        const { loading } = this.state
        return (
            <div>
                <LoadingScreen open={loading} />
                <Dashboard
                    title=""
                    body={this.renderBody()}
                    multiple={false}
                />
                <Footer />
            </div>
        );
    }
}

PasswordChangeContainer.propTypes = {

};

export default withRouter(connect(null, { updateUser, createCode, changeCode, changeState, changeStatusUser, findValidators, updateNextDateChangePassword })(PasswordChangeContainer))
// export default PasswordChangeContainer;
